import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/http";
import { useAuth } from "@/context/AuthContext";

export const TrialBanner = () => {
  const { user } = useAuth();
  const [me, setMe] = useState(null);
  const isAdmin = user && (user.role === "owner" || user.role === "admin");

  useEffect(() => {
    if (isAdmin) api.get("/billing/me").then(({ data }) => setMe(data)).catch(() => {});
  }, [isAdmin]);

  if (!isAdmin || !me) return null;

  const daysLeft = me.trial_end ? Math.max(0, Math.ceil((me.trial_end * 1000 - Date.now()) / 86400000)) : null;
  const trialing = me.status === "trialing" && daysLeft !== null;

  // Free / comped and active tester accounts never see the upgrade nag
  if (me.status === "comped") return null;
  if (me.status === "tester" && daysLeft && daysLeft > 0) return null;

  const needsPlan = !me.subscribed || (me.status && !["trialing", "active"].includes(me.status));

  if (!trialing && !needsPlan) return null;

  return (
    <div className={`flex items-center justify-center gap-2 px-3 py-1 xl:py-2 text-xs xl:text-sm whitespace-nowrap overflow-hidden ${trialing ? "bg-primary/10 text-primary" : "bg-amber-100 text-amber-800"}`} data-testid="trial-banner">
      <span className="font-medium truncate">
        {trialing ? `${daysLeft} ${daysLeft === 1 ? "day" : "days"} left in your trial` : "Start your subscription to keep everything running"}
      </span>
      <Link to="/billing" className="underline font-semibold hover:opacity-80 shrink-0" data-testid="trial-banner-cta">
        {trialing ? "Add payment" : "Choose a plan"}
      </Link>
    </div>
  );
};
